<script>
export default {
  props: {
    wrapperClass: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    dropDownClass: {
      type: String,
      default: '',
    },
    optionClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      value: this.selected,
    };
  },
};
</script>

<template>
  <div :class="wrapperClass">
    <label for="dropdown-select" :class="labelClass">
      {{ label }}
    </label>
    <select
      id="dropdown-select"
      v-model="value"
      name="dropdown-select"
      :class="dropDownClass"
      @change="action(value)"
    >
      <option v-for="option in options" :key="option.key" :class="optionClass">
        {{ option.value }}
      </option>
    </select>
  </div>
</template>
